import React from "react";
import { Link } from "react-router-dom";

// Reusable Button component
// Props: variant: 'primary' | 'secondary' | 'white' | 'ghost'
//        to: optional string route
//        onClick: optional function
//        className: additional classes
const VARIANT_CLASS = {
	primary: "btn-primary",
	secondary: "btn-secondary",
	white: "btn-white",
	ghost: "bg-transparent",
	"primary-gradient": "btn-primary-gradient",
};

export default function Button({ children, variant = 'primary', to, onClick, className = '', type, ...rest }) {
	const base = VARIANT_CLASS[variant] || VARIANT_CLASS.primary;
	const classes = `${base} ${className}`.trim();
	const typeAttr = type || (to ? undefined : 'button');

	if (to) {
		return (
			<Link to={to} className={classes} onClick={onClick} {...rest}>
				{children}
			</Link>
		);
	}

	return (
		<button {...(typeAttr ? { type: typeAttr } : {})} className={classes} onClick={onClick} {...rest}>
			{children}
		</button>
	);
}
